export const environment = {
  production: false,
  apiUrl: 'https://api.dev.denuncianr1.com.br/api/v1',
  localTenantHost: 'demo.dev.denuncianr1.com.br',
  companyUuid: '9c812d00-2cc1-4f4c-9d6d-da4c1a053572',
  whatsappNumber: '5511999999999',
  authSpaUrl: 'https://auth.dev.onefactory.com.br/auth/login',
  authBaseUrl: 'https://api.dev.auth.onefactory.com.br',
  authAdminUrl: 'https://admin.dev.onefactory.com.br',
  authCallbackUrl: 'https://painel.dev.denuncianr1.com.br/auth/callback',
  oauth: {
    clientId: '019ebd1c-3eed-7101-a7b6-7de43a0cb6c6',
  },
};
